import React, { Component } from 'react'
import { Grid, Header, Accordion, Icon, Modal } from 'semantic-ui-react'
import QryInput from './qryInputs';
import QueryOutput from './qryOutput';
import { Provider } from 'react-redux';
import store from './store';
//import ReactToPrint from "react-to-print";
// import { initialValues } from './util';
import { intializeBrokerQryFunc, reconcileFunction, setLoadingState, unsetLoadingState } from './actions/qryInputActions';
import { getRecentQry } from './actions/recentQryActions';
import { qryFuncIcon } from './images'
import _ from 'lodash'
import Draggable from 'react-draggable'
import '../TopHeader/brokerQryFunc.scss'

class QryFuncModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            activeIndex: 0,
            qryType: null,
            modalInstanceKey: 0,
            open: false,
            runAgainClicked: false,
            startedReconcile: false,
        }
        window.BASE_URL = this.props.baseUrl;
        window.engineRequest = props.engineRequest;
        this.resetToInitialState = this.resetToInitialState.bind(this);
        window.qryTimeout = true;
        store.dispatch(intializeBrokerQryFunc());
        // if(props.brokerId && props.recentQryCall){
        //    window.brokerId = props.brokerId; 
        //    store.dispatch(getRecentQry(props.brokerId)) 
        // }
        this.componentRef = React.createRef(); 
        
    }

    resetToInitialState(bumpKey = true) {
        window.qryTimeout = true;
        window.qryResponseTimer && clearTimeout(window.qryResponseTimer);
        window.qryResponseTimer = null;
        store.dispatch(intializeBrokerQryFunc());
        this.setState((prev) => ({
            qryType: null,
            qryTypeFoo: null,
            runAgainClicked: false,
            startedReconcile: false,
            activeIndex: 0,
            widthClass: undefined,
            startTimexx: undefined,
            modalInstanceKey: bumpKey ? (prev.modalInstanceKey || 0) + 1 : prev.modalInstanceKey,
        }));
    }

    componentWillUnmount() {
        this.resetToInitialState(false);
    }

    resize = (e) => {
        let cssClass = e.target.value;
        this.setState({
            "widthClass": cssClass
        })
    }

    handleClick = (e, titleProps) => {
      const { index } = titleProps
      const { activeIndex } = this.state
      const newIndex = activeIndex === index ? -1 : index
  
      this.setState({ activeIndex: newIndex })
    }
    show = (dimmer) => () => this.setState({ dimmer, open: true, startTimexx: Date.now() });
    close = (dimmer) => {
        let dimm = dimmer || 'inverted';
        // Do not remount on close — remount was clearing qryTimeout in QueryOutput.didMount
        // and letting in-flight responses refill outputData.
        this.resetToInitialState(false);
        this.setState({
            dimm,
            open: false
        });
    }

    setQryType = (qryType) => {
       this.setState({"qryType": qryType}); 
    }
    onRunAgainClicked = () => {
      this.setState({"runAgainClicked": true})
    }
    unSetRunAgainClicked= () => {
      this.setState({"runAgainClicked": false})
    }
    onStartReconcileClicked = () => {
      this.setState({"startedReconcile": true})
    }
    unSetStartReconcileClicked= () => {
      this.setState({"startedReconcile": false})
    }
    processReconcile = () => {
        console.log("QUERY RESPONSE PROPS", this.props, this.state)
        store.dispatch(setLoadingState())
        store.dispatch(reconcileFunction({
            shipmentId: this.props.shipId,
            qryType: this.state.qryType,
            bolIdData: this.props.bolIdData
        }));
        store.dispatch(unsetLoadingState())
    }
    render() {
				const { activeIndex } = this.state   
				const isBrokerKnAdmin = _.get(this.props, 'isBrokerKnAdmin', '') === 'BROKER_KN_ADMIN'
                const { nonModalWindow, noDimmerOverlay } = this.props;
                const width = this.state.width || this.props.width;
                const height = this.state.height;
                const modalcontent = <React.Fragment>
                    <i aria-hidden="true" onClick={this.close} className={`close icon  ${nonModalWindow?' nonModalWindowCloseButton ':''}`}></i>
                <Grid className={`qryFuncGrid ${nonModalWindow?' nonModalWindow ':''}`}>
                    <Grid.Row columns={3}>
                        <Grid.Column width={8}></Grid.Column>
                        <Grid.Column width={2}>
                            {!nonModalWindow && 
                                <div className={`qryFuncIcon`}  alt='qry func icon' style={{cursor:'move',backgroundImage:`url(${qryFuncIcon})`}}/>
                            }
                        </Grid.Column>
                        <Grid.Column width={8}></Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={2}>
                       
                        <Grid.Column id="qryFuncLeftPanel" className={`qryFuncLeftPanel seperator`} width={4} style={{"display": (this.props.hideLeftPanel?"none": "block")}}>
                            <div>
                            <Accordion>
                                <Accordion.Title
                                    active={activeIndex === 0}
                                    index={0}
                                    onClick={this.handleClick}
                                >
                                    <Header>Query Input <Icon className={"accordianArrow"} name={activeIndex === 0? 'angle down': 'angle right'} /></Header>
                                </Accordion.Title>
                                <Accordion.Content active={activeIndex === 0}>
                                    <QryInput
                                        key={`qry-input-${this.state.modalInstanceKey}`}
                                        parentThis={this}
                                        unSetRunAgainClicked={this.unSetRunAgainClicked}
                                        runAgainClicked={this.state.runAgainClicked}
                                        {...this.props}
                                        setQryType={this.setQryType}
                                        unSetStartReconcileClicked={this.unSetStartReconcileClicked}
                                        startedReconcile={this.state.startedReconcile}
                                    />
                                </Accordion.Content>
                            </Accordion> 
                            {
                            //     this.props.recentQryCall && 
                            //     <Accordion>       
                            //     <Accordion.Title
                            //         active={activeIndex === 1}
                            //         index={1}
                            //         onClick={this.handleClick}
                            //     >
                            //         <Header>Recent Queries <Icon className={"accordianArrow"} name={activeIndex === 1 ? 'angle down': 'angle right'} /></Header>
                            //     </Accordion.Title>
                            //     <Accordion.Content active={activeIndex === 1}>
                            //         {
                            //             this.props.recentQryCall && <RecentQry {...this.props} setQryType={this.setQryType}/>
                            //         }
                            //     </Accordion.Content>
                            // </Accordion>
                            }
                            </div>    
                        </Grid.Column>
                        
                        {/* <Grid.Column width={1} className={'seperator'}></Grid.Column> */}
                        <Grid.Column  className={`qryFuncRightPanel`} width={width?16:11}>
                            <React.Fragment>
                            <div
                                ref={el => (this.componentRef = el)} 
                                id="qryFuncRightPanel"
                            >
                            <QueryOutput
                                key={`qry-output-${this.state.modalInstanceKey}`}
                                runAgainClicked={this.onRunAgainClicked} 
                                runningAgain={this.state.runAgainClicked}
                                {...this.props} 
                                qryType={this.state.qryType || this.state.qryTypeFoo} 
                                startTimexx={this.state.startTimexx}
                                closeModal={this.close}
                                componentRef={this.componentRef}
                                startedReconcile={this.state.startedReconcile}
                                startReconcileClicked={this.onStartReconcileClicked}
                                processReconcile={this.processReconcile}
                            />
                             </div>
                            <div id='brokerQryToast' className={`toast`}></div>
                            </React.Fragment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                </React.Fragment>;
        
        let launchFrom = this.props.launchFrom+""
        window.GLOBAL_currentContexts = window.GLOBAL_currentContexts || {};//redux is a global anyway >_>
        if(!window.GLOBAL_currentContexts[launchFrom]){
            window.GLOBAL_currentContexts[launchFrom] =React.createContext(launchFrom);
        }
        return (
            <Provider context={window.GLOBAL_currentContexts[launchFrom]} store={store}>
                {nonModalWindow ? 
                    modalcontent :
                    <Draggable handle=".qryFuncIcon"  grid={[10, 10]}><Modal className={this.state.widthClass ? `qryFuncModal ${this.state.widthClass}`: `qryFuncModal`} 
                    style={{ "width": width ? `${width} !important` : "85% !important" }} open={this.state.open} 
                    trigger={<div className={isBrokerKnAdmin ? `customQryBtn kn-admin-type` : `customQryBtn`} 
                    onClick={this.show('inverted')}>
                        <div className={`btnText`}>
                            {this.props.buttontext || 'CUSTOMS QUERIES'}
                        </div>
                    </div>}
                    

                    onOpen={() => {
                        document.getElementById("hideStatusWindow") && document.getElementById("hideStatusWindow").click();
                        // Fresh remount + cleared store so right panel starts at outputPlaceholder
                        this.resetToInitialState(true);
                        this.setState({ open: true, startTimexx: Date.now(), qryType: null, qryTypeFoo: null });
                        setTimeout(()=>{
                            if(noDimmerOverlay){
                                let modawindow = document.getElementsByClassName("ui page modals dimmer transition visible active");
                                modawindow && modawindow[0] && modawindow[0].classList.add('dimmerignoredbackground');
                                // modawindow && modawindow[0] && modawindow[0].classList.remove('dimmer');
                                // let modawindowtwo = document.getElementsByClassName("ui modal transition visible active qryFuncModal react-draggable");
                                // if(modawindowtwo && modawindowtwo[0]){modawindowtwo[0].style.transform = "translate(5vw, 1vh)";}
                            }
                        },0)

                     }}
                    onClose={() => {
                        this.resetToInitialState(false);
                        this.setState({ open: false });
                    }}
                    >
                        {
                        // this.props.hideLeftPanel && 
                        //     <div style={{"margin":"10px"}}><label style={{"paddingLeft":"30px", "paddingRight":"10px"}}> Resize </label>
                        //      <select 
                        //         onChange={this.resize}
                        //     >
                        //     <option value="">Select</option>    
                        //     <option value="">Reset</option>
                        //     <option value="qryFunc100">100%</option>
                        //     <option value="qryFunc90">90%</option>
                        //     <option value="qryFunc80">80%</option>
                        //     <option value="qryFunc70">70%</option>
                        //     <option value="qryFunc60">60%</option>
                        //     <option value="qryFunc50">50%</option>
                        //     <option value="qryFunc40">40%</option>
                        //     </select></div>
                        }
                        {modalcontent}
                    </Modal></Draggable>
                }
            </Provider>
            
        )
    }
}

export default QryFuncModal;
export { QryFuncModal };
export { default as MidQryInput } from './midQryInput';
export { default as QueryOutput } from './qryOutput';
export { default as EsOutput } from './esOutput';
